var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21V8m7 4v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-8m15-4H4a1 1 0 00-1 1v2a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1zm-4.304-1.388C14.618 7.734 12.921 8 12.099 8c0 0-.494-3.116.721-4.38a1.979 1.979 0 012.876 0 2.177 2.177 0 010 2.992zm-7.392 0C9.382 7.734 11.079 8 11.901 8c0 0 .494-3.116-.721-4.38a1.979 1.979 0 00-2.876 0 2.177 2.177 0 000 2.992z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgGift;